// extracted by mini-css-extract-plugin
export var speaker = "speakerlistitem-module--speaker--3v9-D";
export var center = "speakerlistitem-module--center--TT660";
export var image = "speakerlistitem-module--image--18baY";
export var left = "speakerlistitem-module--left--2Kp3N";
export var right = "speakerlistitem-module--right--1hscQ";